/* B2B saved lists (wishlist). Guest storage in localStorage ('b2b-lists');
   logged-in customers sync through the /apps/lists app proxy (HMAC-verified
   FastAPI service in pipeline/lists_service.py) writing the customer
   metafield lists.saved. Falls back to guest storage when the proxy is not
   configured. Config from [data-lists-config] JSON in theme.liquid. */
if (!window.__listsB2B) {
  window.__listsB2B = true;

  (function () {
    'use strict';

    var cfgEl = document.querySelector('[data-lists-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
    if (!cfg.enabled) return;
    if (!cfg.customerId && !cfg.guestEnabled) return;

    var KEY = 'b2b-lists';
    var proxyOk = null; /* null = untested */

    function load() {
      var data;
      try { data = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
      if (!data || typeof data !== 'object' || !data.lists) {
        data = { lists: { 'default': { name: cfg.defaultName || 'My list', items: [] } } };
      }
      /* migrate the legacy cart save-for-later store once */
      try {
        var legacy = JSON.parse(localStorage.getItem('saved-for-later') || '[]');
        if (legacy.length) {
          legacy.forEach(function (item) { addItemLocal(data, 'default', item, 1); });
          localStorage.removeItem('saved-for-later');
        }
      } catch (e) {}
      return data;
    }

    function save(data) {
      try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
      syncRemote(data);
      render();
    }

    function addItemLocal(data, listId, item, qty) {
      var list = data.lists[listId] || data.lists['default'];
      var existing = list.items.find(function (i) { return String(i.variantId) === String(item.variantId); });
      if (existing) existing.qty = (existing.qty || 1) + 0; /* keep qty, no dupes */
      else list.items.push({
        variantId: item.variantId,
        handle: item.handle || '',
        title: item.title || '',
        price: item.price || '',
        url: item.url || '',
        qty: qty || 1
      });
    }

    function totalCount(data) {
      var n = 0;
      Object.keys(data.lists).forEach(function (k) { n += data.lists[k].items.length; });
      return n;
    }

    function isSaved(data, variantId) {
      return Object.keys(data.lists).some(function (k) {
        return data.lists[k].items.some(function (i) { return String(i.variantId) === String(variantId); });
      });
    }

    /* ---------- remote sync (logged-in only) ---------- */
    function syncRemote(data) {
      if (!cfg.customerId || proxyOk === false) return;
      fetch('/apps/lists', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'set', lists: data.lists })
      })
        .then(function (r) { proxyOk = r.ok; updateSyncStatus(); })
        .catch(function () { proxyOk = false; updateSyncStatus(); });
    }

    /* Signed-in customers only ever see "sync unavailable" copy when we've
       actually tried the proxy and it failed - never on the untested (null)
       state, so there's no flash of a false warning before pullRemote settles,
       and never a false "it's syncing" implication once we know it isn't. */
    function updateSyncStatus() {
      var show = !!cfg.customerId && proxyOk === false;
      document.querySelectorAll('[data-lists-sync-status]').forEach(function (el) {
        el.hidden = !show;
        if (show) el.textContent = cfg.syncUnavailable || "Lists aren't syncing to your account right now - saved on this device only.";
      });
    }

    function pullRemote() {
      if (!cfg.customerId) return;
      fetch('/apps/lists')
        .then(function (r) {
          if (!r.ok) { proxyOk = false; return null; }
          proxyOk = true;
          return r.json();
        })
        .then(function (remote) {
          updateSyncStatus();
          if (!remote || !remote.lists) return;
          var data = load();
          var guestItems = totalCount(data);
          /* merge guest items into the remote copy, then adopt it */
          Object.keys(data.lists).forEach(function (k) {
            var target = remote.lists[k] || remote.lists['default'];
            if (!target) { remote.lists[k] = data.lists[k]; return; }
            data.lists[k].items.forEach(function (item) {
              if (!target.items.some(function (i) { return String(i.variantId) === String(item.variantId); })) {
                target.items.push(item);
              }
            });
          });
          try { localStorage.setItem(KEY, JSON.stringify(remote)); } catch (e) {}
          if (guestItems) syncRemote(remote);
          render();
        })
        .catch(function () { proxyOk = false; updateSyncStatus(); });
    }

    /* ---------- UI ---------- */
    function toast(message) {
      var el = document.querySelector('.cart-toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'cart-toast';
        el.setAttribute('role', 'status');
        document.body.appendChild(el);
      }
      el.textContent = message;
      el.classList.add('cart-toast--visible');
      clearTimeout(el._timer);
      el._timer = setTimeout(function () { el.classList.remove('cart-toast--visible'); }, 3200);
    }

    function render() {
      var data = load();
      var count = totalCount(data);
      document.querySelectorAll('[data-lists-count]').forEach(function (el) {
        el.textContent = count > 0 ? count : '';
        el.hidden = count === 0;
      });
      document.querySelectorAll('[data-add-to-list]').forEach(function (btn) {
        btn.classList.toggle('is-saved', isSaved(data, btn.getAttribute('data-variant-id')));
      });
    }

    /* single delegated handler; wins over the legacy handlers in plp/pdp js
       via capture so items land in the lists store */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-list]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var data = load();
      var variantId = btn.getAttribute('data-variant-id');
      if (isSaved(data, variantId)) {
        /* toggle off */
        Object.keys(data.lists).forEach(function (k) {
          data.lists[k].items = data.lists[k].items.filter(function (i) {
            return String(i.variantId) !== String(variantId);
          });
        });
        save(data);
        return;
      }
      addItemLocal(data, 'default', {
        variantId: variantId,
        handle: btn.getAttribute('data-item-handle') || btn.getAttribute('data-product-handle') || '',
        title: btn.getAttribute('data-item-title') || '',
        price: btn.getAttribute('data-item-price') || '',
        url: btn.getAttribute('data-item-url') || ''
      }, 1);
      save(data);
      var listName = data.lists['default'].name;
      if (cfg.customerId) toast((cfg.toast || 'Saved to {list}').replace('{list}', listName));
      else toast(cfg.toastGuest || 'Saved to My list - Sign in to keep it');
    }, true);

    /* cart: move every line into the default list, then clear the cart */
    document.addEventListener('click', function (e) {
      var move = e.target.closest('[data-move-all-list]');
      if (!move) return;
      if (move.hasAttribute('data-busy')) return;
      move.setAttribute('data-busy', '');
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cartData) {
          var data = load();
          cartData.items.forEach(function (item) {
            addItemLocal(data, 'default', {
              variantId: item.variant_id,
              handle: item.handle,
              title: item.product_title,
              price: '$' + (item.final_price / 100).toFixed(2),
              url: item.url ? item.url.split('?')[0] : ''
            }, item.quantity);
          });
          save(data);
          return fetch('/cart/clear.js', { method: 'POST' });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          toast((cfg.toast || 'Saved to {list}').replace('{list}', load().lists['default'].name));
        })
        .catch(function () {})
        .then(function () { move.removeAttribute('data-busy'); });
    });

    window.B2BLists = {
      load: load,
      save: save,
      isSaved: function (variantId) { return isSaved(load(), variantId); },
      createList: function (name) {
        var data = load();
        var id = 'l' + Date.now();
        data.lists[id] = { name: name, items: [] };
        save(data);
        return id;
      },
      renameList: function (id, name) {
        var data = load();
        if (data.lists[id]) { data.lists[id].name = name; save(data); }
      },
      deleteList: function (id) {
        var data = load();
        if (id !== 'default' && data.lists[id]) { delete data.lists[id]; save(data); }
      },
      moveCartToList: function (items) {
        var data = load();
        items.forEach(function (item) { addItemLocal(data, 'default', item, item.qty || 1); });
        save(data);
      }
    };

    render();
    pullRemote();
  })();
}
